const DEFAULT_APP_TITLE = 'Oil Climate Index plus Gas';
const DEFAULT_APP_DESCRIPTION = 'Assessing Global Oil and Gas Emissions';

const readString = (value, fallback = '') =>
  typeof value === 'string' ? value : fallback;

export const appTitle = readString(
  import.meta.env.APP_TITLE,
  DEFAULT_APP_TITLE
);

export const appDescription = readString(
  import.meta.env.APP_DESCRIPTION,
  DEFAULT_APP_DESCRIPTION
);

export const appVersion = readString(import.meta.env.APP_VERSION);
export const appBuildTime = Number(import.meta.env.APP_BUILD_TIME) || 0;
export const mapboxToken = readString(import.meta.env.MAPBOX_TOKEN);
export const formAssemblyContactEndpoint = readString(
  import.meta.env.FORM_ASSEMBLY_CONTACT_ENDPOINT
);
export const formAssemblyDownloadEndpoint = readString(
  import.meta.env.FORM_ASSEMBLY_DOWNLOAD_ENDPOINT
);
export const downloadDataFilename = readString(
  import.meta.env.DOWNLOAD_DATA_FILENAME,
  'ociplus_info.zip'
);
export const publicUrl = readString(import.meta.env.PUBLIC_URL);
export const baseUrl = readString(import.meta.env.BASE_URL, '/');
export const isDevelopment = import.meta.env.DEV;
